export default __webpack_public_path__ + "static/media/icon-seventh-explosion.3f10c9c2.svg";